const IMAGE_EXTENSIONS = new Set([
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "bmp",
  "tif",
  "tiff",
]);

const FILE_TONE = {
  pdf: "#e55353",
  xls: "#2dce89",
  xlsx: "#2dce89",
  xlsm: "#2dce89",
  csv: "#2dce89",
  doc: "#1d8cf8",
  docx: "#1d8cf8",
  ppt: "#fd7e14",
  pptx: "#fd7e14",
  txt: "#8898aa",
};

export const MAX_EMAIL_ATTACHMENT_BYTES = 15 * 1024 * 1024;
export const MAX_EMAIL_ATTACHMENTS = 15;

export const extensionOf = (name = "") =>
  String(name).split(".").pop()?.toLowerCase() || "";

export const isImageName = (name = "", mime = "") =>
  IMAGE_EXTENSIONS.has(extensionOf(name)) || String(mime).startsWith("image/");

export const fileTone = (name = "") => FILE_TONE[extensionOf(name)] || "#8898aa";

export const fileLabel = (name = "") => {
  const ext = extensionOf(name);
  return (ext || "file").slice(0, 4).toUpperCase();
};

export const formatBytes = (bytes) => {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size < 0) return "";
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(size < 10 * 1024 ? 1 : 0)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error || new Error("Could not read file"));
    reader.readAsDataURL(file);
  });

const ACCEPTED_EXTENSIONS = new Set([
  "pdf",
  "xls",
  "xlsx",
  "xlsm",
  "csv",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "txt",
  "rtf",
  ...IMAGE_EXTENSIONS,
]);

export const isAcceptedEmailFile = (file) => {
  const ext = extensionOf(file?.name || "");
  const mime = String(file?.type || "");
  if (ACCEPTED_EXTENSIONS.has(ext)) return true;
  if (mime.startsWith("image/")) return true;
  return (
    mime === "application/pdf" ||
    mime === "text/csv" ||
    mime === "text/plain" ||
    mime.includes("spreadsheet") ||
    mime.includes("excel") ||
    mime.includes("word") ||
    mime.includes("presentation")
  );
};
